module.exports = __webpack_public_path__ + "static/the-elephant-in-the-brain-2c0dde8a329db53b892f1762327e1d46.jpg";